module.exports = __webpack_public_path__ + "img/UtilityTechBackgroundC03_ua.a647d327.webp";